import React from "react";
import GeneralModal from "./GeneralModal";
import KnockoutLockedModal from "../Picks/KnockoutPicks/KnockoutLockedModal";
import SubmitPicksModal from "../Picks/SubmitPicksModal";

const MODAL_COMPONENTS = {
  GENERAL_MODAL: GeneralModal,
  KO_LOCKED_MODAL: KnockoutLockedModal,
  SUBMIT_PICKS_MODAL: SubmitPicksModal,
};

const RootModal = (props) => {
  if (!props.modalType) {
    return null;
  }
  const SpecificModal = MODAL_COMPONENTS[props.modalType];

  // @ts-ignore
  return <SpecificModal {...props.modalProps} />;
};

export default RootModal;
